import React from 'react';
import { ArrowRightIcon, LandmarkIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
export function FinanceCallout() {
  return <section className="w-full bg-white pt-20" aria-label="Business Financing" data-id="element-976" data-mp="1i3qpswqt5ovc">
      <div className="mx-auto max-w-shell px-6" data-id="element-977" data-mp="1n568ii5ijjak">
        <div className="rounded-[14px] bg-brand-soft px-6 py-5 sm:px-8" data-id="element-978" data-mp="1s3hiqtzpzvtb">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between" data-id="element-979" data-mp="1s1n602ylra0b">
            <p className="flex items-start gap-3 text-[16px] font-medium leading-[1.5] text-ink" data-id="element-980" data-mp="udwc6cynzwa1">
              <LandmarkIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-981" data-mp="zczhzzmgy6j2" />
              Need working capital? Eligible Kayko businesses with at least 90 days of active business records can
              apply for financing.
            </p>
            <SmartLink href="/products/business-finance" className="inline-flex shrink-0 items-center gap-1.5 pl-8 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover md:pl-0" data-id="element-982" data-mp="bogb9oj2i1t3">
              Learn about Business Financing
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-983" data-mp="2gxss4nfx59c7" />
            </SmartLink>
          </div>
          <p className="mt-3 pl-8 text-[12px] text-ink-muted" data-id="element-984" data-mp="2c47wv35pmtgp">
            Subject to eligibility and approval. Financing provided by Mula Financial Services Ltd.
          </p>
        </div>
      </div>
    </section>;
}